import * as React from 'react';

const Edit = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.4 7.34L16.66 4.6C15.92 3.905 14.776 3.875 14 4.53L4.99999 13.53C4.67699 13.856 4.47599 14.283 4.42999 14.74L3.99999 18.91C3.97299 19.207 4.07899 19.5 4.28999 19.71C4.47899 19.897 4.73399 20.002 4.99999 20H5.08999L9.25999 19.62C9.71699 19.574 10.144 19.373 10.47 19.05L19.47 10.05C20.197 9.282 20.166 8.07 19.4 7.34ZM9.07999 17.62L6.07999 17.9L6.34999 14.9L12 9.32L14.7 12.02L9.07999 17.62ZM16 10.68L13.32 8L15.27 6L18 8.73L16 10.68Z" fill="currentColor"/>
  </svg>
);

export default Edit;
